import React from 'react';
import CategoryMenuCards from '../CategoryMenuCards/CategoryMenuCards';

const ModuleCategoryMenuCards = ({ primaryColor }) => {
  return <CategoryMenuCards primaryColor={primaryColor} />;
};

export default ModuleCategoryMenuCards;
